// deviceCarrier.js
// ─────────────────────────────────────────────────────────────────────────
// React Native shell se device ka CARRIER poochta hai, taaki carrier screen
// pe user ko apna carrier pehle se chuna hua mile.
//
// Bridge ek-tarfa nahi hai: hum `{ type: "Carrier" }` post karte hain, aur
// native uska jawab ek "message" event me wapas bhejta hai. Jawab TURANT nahi
// aata, aur tab tak user agli screen pe ja chuka hota hai — isliye listener
// window/document pe module level pe rehta hai (kisi component ke saath nahi
// marta) aur jawab sessionStorage me rakh deta hai.
//
// iOS `window` pe deliver karta hai, Android `document` pe — dono sunte hain,
// bilkul waise hi jaise GlobalCallContext ka END_CALL listener karta hai.
// ─────────────────────────────────────────────────────────────────────────

const STORAGE_KEY = "deviceCarrier";
const REQUEST_TYPE = "Carrier";

// Native ka jawab in me se kisi bhi shakl me aa sakta hai, isliye teeno dekhte
// hain. Type-match case-insensitive hai — native "carrier"/"CARRIER" bhej de to
// bhi chale.
const readCarrierFromMessage = (data) => {
    if (!data) return "";
    const type = String(data.type || "").toLowerCase();
    if (type !== REQUEST_TYPE.toLowerCase()) return "";
    const value = data.carrier ?? data.value ?? data.payload ?? data.data;
    return typeof value === "string" ? value.trim() : "";
};

let listenerInstalled = false;
// Jo screens carrier ka intezaar kar rahi hain. Jawab der se aa sakta hai —
// carrier screen tab tak mount ho chuki hoti hai — isliye sirf sessionStorage
// me rakhna kaafi nahi, sunane walon ko batana bhi padta hai.
const subscribers = new Set();

const installListener = () => {
    if (listenerInstalled || typeof window === "undefined") return;
    listenerInstalled = true;

    const onMessage = (event) => {
        try {
            const data =
                typeof event.data === "string" ? JSON.parse(event.data) : event.data;
            const carrier = readCarrierFromMessage(data);
            if (!carrier) return; // hamara message nahi
            try {
                sessionStorage.setItem(STORAGE_KEY, carrier);
            } catch {
                /* storage blocked — subscribers phir bhi chal jaayenge */
            }
            console.log("[deviceCarrier] native se mila:", carrier);
            subscribers.forEach((cb) => {
                try {
                    cb(carrier);
                } catch (_e) {
                    /* ek subscriber ka error baaki ko na rok de */
                }
            });
        } catch (_e) {
            /* JSON nahi tha ya kisi aur ka message — ignore */
        }
    };

    window.addEventListener("message", onMessage);
    document.addEventListener("message", onMessage);
};

/**
 * Carrier milte hi batao.
 *
 * Value pehle se aa chuki ho to TURANT call ho jaata hai — isse ye farq nahi
 * padta ki jawab screen mount hone se pehle aaya ya baad me.
 *
 * @returns unsubscribe function
 */
export const onDeviceCarrier = (cb) => {
    if (typeof cb !== "function") return () => {};
    installListener();
    const existing = getDeviceCarrier();
    if (existing) {
        cb(existing);
        return () => {};
    }
    subscribers.add(cb);
    return () => subscribers.delete(cb);
};

/**
 * Native se carrier maango. Web par chup-chaap no-op.
 *
 * Jawab ka intezaar nahi karte — wo baad me aayega aur sessionStorage me chala
 * jayega. Carrier screen mount hote waqt getDeviceCarrier() se padh legi.
 */
export const requestDeviceCarrier = () => {
    if (typeof window === "undefined" || !window.ReactNativeWebView) return false;
    installListener();
    try {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: REQUEST_TYPE }));
        return true;
    } catch (err) {
        console.error("[deviceCarrier] postMessage failed:", err);
        return false;
    }
};

/** Native ne jo carrier bataya (na mila to ""). */
export const getDeviceCarrier = () => {
    try {
        return sessionStorage.getItem(STORAGE_KEY) || "";
    } catch {
        return "";
    }
};

export const clearDeviceCarrier = () => {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        /* ignore */
    }
};
